import React, { useContext, useState, useEffect } from "react";
import { AuthContext } from "../../Contexts/auth";
// import CreateTurmas from "../../pages/CreateTurmas/CreateTurmas";
import Campaigns from "../Campaigns/Campaigns";
import './styles.css';

const HomePage = () => {
  const { authenticated, logout } = useContext(AuthContext);
  const [user, setUser] = useState({});
  const [turmas, setTurmas] = useState([]);

  const handleLogout = () => {
    logout();
  };

  useEffect(() => {
    const user = JSON.parse(localStorage.getItem('user'));
    if (user) {
      setUser(user);
      console.log(user);
    };
  }, []);

  useEffect(() => {
    const turmas = JSON.parse(localStorage.getItem('turmas'));
    if (turmas) {
      setTurmas(turmas);
      console.log(turmas);
    };
  }, []);

  return (
    <div id="home">
      {/* <button className="logout_btn" onClick={handleLogout}>
        Sair
      </button> */}
      <div className="parent-welcome">
        {/* <h3>Home</h3> */}
      </div>
      <div className="carousel-item">
      </div>
      {/* <CreateTurmas /> */}
      <Campaigns />
      <p>{String(authenticated)}</p>
    </div>
  );
};

export default HomePage;
